import React from "react";
import { IBaseProperty, IPropertyEditorProps, IUIPropertyDefinition } from "../common";
import { Property, PropertyContainer, PropertyContainerTitle, PropertyGroup, PropertyTitle } from "./common";
import { Checkbox, Input } from "uxp/components";
import { hasValue } from "../../../util";
import { $L } from '../../../localize';

export interface IRoundOffProperty extends IBaseProperty {
    integer?: boolean,
    decimalPoints?: number,
    units?: string,
}

export function roundOffValue(value: number, options: IRoundOffProperty) {
    if (!value) return value
    if (options?.integer) {
        return (''+(Math.round(value + Number.EPSILON))) + (options?.units ||'')
    }
    else {
        let numOfDecimals = hasValue(options?.decimalPoints, true) ? options?.decimalPoints : 2
        const base = Math.pow(10, numOfDecimals)
        return (''+(Math.round((value + Number.EPSILON) * base) / base)) +   (options?.units ||'');
    }
}
export function RoundOffPropertyEditor(props:{roundOff:IRoundOffProperty,onChange:(f:IRoundOffProperty)=>void}) {
    const _props = props.roundOff;
    return <><Property>

    <Checkbox
        checked={_props.integer}
        onChange={s => {
            props.onChange(Object.assign({}, _props, { integer: s }))
        }}
        label={$L('widgetdesigner.props.round-off-whole', 'Round off to nearest whole number')}
    />

</Property>

{!_props?.integer &&
    <Property>
        <PropertyTitle>{$L('widgetdesigner.props.decimal-points', 'Number of decimal points')}</PropertyTitle>
        <Input
            type='number'
            value={_props.decimalPoints?.toString() || '2'}
            onChange={s => {
                let n = Number(s)
                if (!n || isNaN(n)) n = 2
                if (n < 0) n = 0
                if (n > 10) n = 10
                props.onChange(Object.assign({}, _props, { decimalPoints: n }))
            }}
            inputAttr={{
                min: '0',
                max: '10'
            }}
        />
    </Property>}
    </>;
}
export function RoundOffProperty(defaultProps: IRoundOffProperty, title?: string,useUnits?:boolean): IUIPropertyDefinition<IRoundOffProperty> {
    return {
        defaults: defaultProps,
        render: (props, uxpContext, data, containerId) => {

            let _props = props?.uiProps
            return <PropertyContainer>
                <PropertyContainerTitle>   {title || $L('widgetdesigner.props.round-off', 'Round Off')}</PropertyContainerTitle>

                <PropertyGroup>
                    <Property>

                        <Checkbox
                            checked={_props.integer}
                            onChange={s => {
                                props.onChange(Object.assign({}, _props, { integer: s }))
                            }}
                            label={$L('widgetdesigner.props.round-off-whole', 'Round off to nearest whole number')}
                        />

                    </Property>

                    {!_props?.integer &&
                        <Property>
                            <PropertyTitle>{$L('widgetdesigner.props.decimal-points', 'Number of decimal points')}</PropertyTitle>
                            <Input
                                type='number'
                                value={_props.decimalPoints?.toString() || '2'}
                                onChange={s => {
                                    let n = Number(s)
                                    if (!n || isNaN(n)) n = 2
                                    if (n < 0) n = 0
                                    if (n > 10) n = 10
                                    props.onChange(Object.assign({}, _props, { decimalPoints: n }))
                                }}
                                inputAttr={{
                                    min: '0',
                                    max: '10'
                                }}
                            />
                        </Property>
                    }
                    {useUnits &&
                    <Property>
                    <PropertyTitle>{$L('widgetdesigner.props.units', 'Units')}</PropertyTitle>
                    <Input
                        type='text'
                        value={_props.units?.toString() || ''}
                        onChange={s => {
                            props.onChange(Object.assign({}, _props, { units: s }))
                        }}
                       
                    />
                </Property>

                    }
                </PropertyGroup>
            </PropertyContainer>
        }
    }
}
